export const LOADER_MESSAGES = ['Locating workflow information...', 'Creating workflow tasks...'];

export const OBLIGATION_TASKS_HINT_TIMEOUT = 5000;
